import React from "react"

import TextInput from "@/pages/Attendance/Chat/ConversationPanel/Input/TextInput"
import { ButtonMessageData } from "@/protocols/channel"
import { Grid, IconButton, InputAdornment } from "@material-ui/core"
import {
	Close as CloseIcon
} from "@material-ui/icons"
import { ValidationType } from "@/hooks/useValidation"
import { Text, themeColors } from "letalkui"

type ManageTemplatePhoneNumberButtonProps = {
	index: number
	button: ButtonMessageData
	validation?: ValidationType
	handleButtonTextChange: (text: string, index: number) => void
	handleRemoveButtons: (index: number) => void
	handleAddPhoneNumber: (phoneNumber: string, index: number) => void
}

const ManageTemplatePhoneNumberButton: React.FC<ManageTemplatePhoneNumberButtonProps> = (props) => {
	const { button, index, validation, handleButtonTextChange, handleRemoveButtons, handleAddPhoneNumber } = props
	return (
		<Grid item>
			<Grid container alignItems="center" direction="row" spacing={2} xs={12}>
				<Grid item xs={6}>
					<TextInput
						placeholder="Nome do botão"
						defaultValue={button?.text}
						inputProps={{ maxLength: 25 }}
						isOutlined
						onMedia={() => ""}
						onSubmit={() => ""}
						onChange={(value) => handleButtonTextChange(value || button.text, index)}
					/>
					{!!validation?.[`buttons[${index}].text`] && (
						<Grid item>
							<Text.Body
								type="smaller2"
								color={themeColors.getTextErrorColor()}
							>
								{validation[`buttons[${index}].text`]}
							</Text.Body>
						</Grid>
					)}
				</Grid>
				<Grid item xs={5}>
					<TextInput
						placeholder="Número de telefone"
						defaultValue={button?.phone_number}
						isOutlined
						inputProps={{ maxLength: 25 }}
						onMedia={() => ""}
						onSubmit={() => ""}
						onChange={(value) => handleAddPhoneNumber(value || "", index)}
					/>
					{!!validation?.[`buttons[${index}].phone_number`] && (
						<Grid item>
							<Text.Body
								type="smaller2"
								color={themeColors.getTextErrorColor()}
							>
								{validation[`buttons[${index}].phone_number`]}
							</Text.Body>
						</Grid>
					)}
				</Grid>
				<Grid item xs={1}>
					<InputAdornment position="end">
						<IconButton size="small" onClick={() => handleRemoveButtons(index)}>
							<CloseIcon fontSize="small" />
						</IconButton>
					</InputAdornment>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default ManageTemplatePhoneNumberButton
